import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbIcon } from "abreact/misc/AbIcon";
import * as React from 'react';
/**
 * This component is made to render colors as a small square.
 * @param props
 * @constructor
 */
export function AbColorViewer(props) {
  const className = ReactUtils.componentClassNamesString("ab-color-viewer", props);
  let color = props.color !== "" ? props.color : "var(--ab-global-color-white)";
  return /*#__PURE__*/React.createElement(AbIcon, _extends({}, props, {
    dataTestId: `color-viewer-${color}`,
    image: "ab:transparent",
    className: className,
    style: {
      backgroundColor: color
    }
  }));
}
//# sourceMappingURL=AbColorViewer.js.map
